import { render, staticRenderFns } from "./TableBox.vue?vue&type=template&id=3058d370"
import script from "./TableBox.vue?vue&type=script&lang=js"
export * from "./TableBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports